export var getPanelStyles = function (props) {
    var theme = props.theme;
    var styles = {
        overlay: {
            backgroundColor: theme.palette.blackTranslucent40
        }
    };
    return styles;
};
//# sourceMappingURL=Panel.styles.js.map